export default __webpack_public_path__ + "static/media/light-dark-theme-icon.2522b582.svg";